import PropTypes from "prop-types";
import { Check, X } from "lucide-react";
import { cn } from "@/lib/utils";

function IndicatorIcon({ compliant }) {
  return (
    <span
      className={cn(
        "inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-white",
        compliant ? "bg-[#00a03b]" : "bg-red-600"
      )}
      aria-hidden
    >
      {compliant ? (
        <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
      ) : (
        <X className="h-3.5 w-3.5" strokeWidth={2.5} />
      )}
    </span>
  );
}

const ComplianceIndicator = ({
  value,
  loading = false,
  className = "",
  showLabel = false,
}) => {
  if (loading) {
    return null;
  }

  if (value === true || value === false) {
    const label = value ? "Compliant" : "Non-Compliant";
    const colorClass = value ? "text-[#00a03b]" : "text-red-600";

    return (
      <span
        className={cn(
          "inline-flex items-center gap-1.5 text-sm font-semibold",
          colorClass,
          className
        )}
        title={label}
        aria-label={label}
        data-testid={
          value
            ? "view-paf-compliance-indicator-compliant"
            : "view-paf-compliance-indicator-non-compliant"
        }
      >
        <IndicatorIcon compliant={value} />
        {showLabel ? <span>{label}</span> : <span className="sr-only">{label}</span>}
      </span>
    );
  }

  return null;
};

ComplianceIndicator.propTypes = {
  value: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  showLabel: PropTypes.bool,
};

export default ComplianceIndicator;
